import { createReducer } from '../../../../utils/reducerUtil';
import { ACTION_STATUS } from '../../../../utils/ActionStatus';

import {
  ON_LICENSE_QUERY_INPUT_CHANGE,
  START_LOAD_LICENSE_EMPLOYEE_OPTIONS,
  LOAD_LICENSE_EMPLOYEE_OPTIONS_SUCCESS,
  LOAD_LICENSE_EMPLOYEE_OPTIONS_FAILURE,
  INIT_LOAD_LICENSE_EMPLOYEE_OPTIONS_ACTION_STATUS,
  START_LOAD_LICENSE_INFO,
  LOAD_LICENSE_INFO_SUCCESS,
  LOAD_LICENSE_INFO_FAILURE,
  INIT_LOAD_LICENSE_INFO_ACTION_STATUS,
  SELECT_LICENSE_INFO,
  OPEN_ADD_OR_EDIT_LICENSE_MODAL,
  ADD_OR_EDIT_LICENSE_CHANGE_INPUT,
  START_ADD_OR_EDIT_LICENSE,
  ADD_OR_EDIT_LICENSE_SUCCESS,
  ADD_OR_EDIT_LICENSE_FAILURE,
  INIT_ADD_OR_EDIT_LICENSE_ACTION_STATUS,
  RESET_ADD_OR_EDIT_LICENSE_MODAL,
  OPEN_DEL_LICENSE_MODAL,
  START_DEL_LICENSE,
  DEL_LICENSE_SUCCESS,
  DEL_LICENSE_FAILURE,
  INIT_DEL_LICENSE_ACTION_STATUS,
  RESET_DEL_LICENSE_MODAL,
  START_LOAD_LICENSE_NOTE,
  LOAD_LICENSE_NOTE_SUCCESS,
  LOAD_LICENSE_NOTE_FAILURE,
  INIT_LOAD_LICENSE_NOTE_ACTION_STATUS,
  LICENSE_NOTE_CHANGE_INPUT,
  START_ADD_OR_EDIT_LICENSE_NOTE,
  ADD_OR_EDIT_LICENSE_NOTE_SUCCESS,
  ADD_OR_EDIT_LICENSE_NOTE_FAILURE,
  INIT_ADD_OR_EDIT_LICENSE_NOTE_ACTION_STATUS,
  RESET_LICENSE_NOTE_MODAL,
} from './LicenseConstants';

const initialAddOrEditFields = {
  id: null,
  employee: '',
  country: '',
  registration: '',
  license: '',
  role: '',
  licenseNo: '',
  licenseDate: '',
  cessationDate: '',
  examStatus: '',
  attachment: '',
  attachmentOriginName: '',
  fileList: [],
};

const initialState = {
  employeeOptions: [],
  licenseQueryFields: {
    employee: '',
    regulator: '',
    showAll: false,
  },
  loadLicenseEmployeeOptionsActionStatus: ACTION_STATUS.READY,
  loadLicenseInfoActionStatus: ACTION_STATUS.READY,
  loadLicenseInfoResp: null,
  selectedLicenseInfoArray: [],
  addOrEditLicenseModal: {
    isOpened: false,
    mode: 'ADD',
    respErrMsg: '',
    fields: initialAddOrEditFields,
  },
  addOrEditLicenseActionStatus: ACTION_STATUS.READY,
  delLicenseModal: {
    isOpened: false,
    respErrMsg: '',
    fields: {
      id: null,
    },
  },
  delLicenseActionStatus: ACTION_STATUS.READY,
  licenseNoteModal: {
    isOpened: false,
    respErrMsg: '',
    fields: {
      id: null,
      note: '',
    },
  },
  loadLicenseNoteActionStatus: ACTION_STATUS.READY,
  addOrEditLicenseNoteActionStatus: ACTION_STATUS.READY,
};

function onLicenseQueryInputChange(state, { name, value }) {
  return {
    ...state,
    licenseQueryFields: {
      ...state.licenseQueryFields,
      [name]: value,
    },
  };
}

function startLoadLicenseEmployeeOptions(state) {
  return {
    ...state,
    loadLicenseEmployeeOptionsActionStatus: ACTION_STATUS.LOGINING,
  };
}

function loadLicenseEmployeeOptionsSuccess(state, resp) {
  return {
    ...state,
    loadLicenseEmployeeOptionsActionStatus: ACTION_STATUS.SUCCESS,
    employeeOptions: resp && resp.data ? resp.data : [],
  };
}

function loadLicenseEmployeeOptionsFailure(state) {
  return {
    ...state,
    loadLicenseEmployeeOptionsActionStatus: ACTION_STATUS.ERROR,
  };
}

function initLoadLicenseEmployeeOptionsActionStatus(state) {
  return {
    ...state,
    loadLicenseEmployeeOptionsActionStatus: ACTION_STATUS.READY,
  };
}

function startLoadLicenseInfo(state) {
  return {
    ...state,
    loadLicenseInfoActionStatus: ACTION_STATUS.LOGINING,
  };
}

function loadLicenseInfoSuccess(state, resp) {
  return {
    ...state,
    loadLicenseInfoActionStatus: ACTION_STATUS.SUCCESS,
    loadLicenseInfoResp: resp,
  };
}

function loadLicenseInfoFailure(state, err) {
  return {
    ...state,
    loadLicenseInfoActionStatus: ACTION_STATUS.ERROR,
    loadLicenseInfoResp: err,
  };
}

function initLoadLicenseInfoActionStatus(state) {
  return {
    ...state,
    loadLicenseInfoActionStatus: ACTION_STATUS.READY,
    selectedLicenseInfoArray: [],
  };
}

function selectLicenseInfo(state, array) {
  return {
    ...state,
    selectedLicenseInfoArray: array,
  };
}

function openAddOrEditLicenseModal(state, { mode, data }) {
  if (mode === 'ADD' || !data) {
    return {
      ...state,
      addOrEditLicenseModal: {
        ...state.addOrEditLicenseModal,
        isOpened: true,
        mode,
        respErrMsg: '',
        fields: initialAddOrEditFields,
      },
    };
  }

  const isCopy = mode === 'COPY';
  return {
    ...state,
    addOrEditLicenseModal: {
      ...state.addOrEditLicenseModal,
      isOpened: true,
      mode,
      respErrMsg: '',
      fields: {
        id: isCopy ? null : data.id,
        employee: data.employee || '',
        country: data.country || '',
        registration: data.registration || '',
        license: data.license || '',
        role: data.role || '',
        licenseNo: data.licenseNo || '',
        licenseDate: data.licenseDate || '',
        cessationDate: isCopy ? '' : (data.cessationDate || ''),
        examStatus: data.examStatus || '',
        attachment: data.attachment || '',
        attachmentOriginName: data.attachmentOriginName || '',
        fileList: data.attachment ? [{
          uid: '-1',
          name: data.attachmentOriginName || data.attachment,
          status: 'done',
          url: data.attachment,
        }] : [],
      },
    },
  };
}

function addOrEditLicenseChangeInput(state, { name, value }) {
  return {
    ...state,
    addOrEditLicenseModal: {
      ...state.addOrEditLicenseModal,
      fields: {
        ...state.addOrEditLicenseModal.fields,
        [name]: value,
      },
    },
  };
}

function startAddOrEditLicense(state) {
  return {
    ...state,
    addOrEditLicenseActionStatus: ACTION_STATUS.LOGINING,
  };
}

function addOrEditLicenseSuccess(state) {
  return {
    ...state,
    addOrEditLicenseActionStatus: ACTION_STATUS.SUCCESS,
  };
}

function addOrEditLicenseFailure(state, err) {
  return {
    ...state,
    addOrEditLicenseActionStatus: ACTION_STATUS.ERROR,
    addOrEditLicenseModal: {
      ...state.addOrEditLicenseModal,
      respErrMsg: err && err.respMessage ? err.respMessage : '',
    },
  };
}

function initAddOrEditLicenseActionStatus(state) {
  return {
    ...state,
    addOrEditLicenseActionStatus: ACTION_STATUS.READY,
  };
}

function resetAddOrEditLicenseModal(state) {
  return {
    ...state,
    addOrEditLicenseModal: {
      ...initialState.addOrEditLicenseModal,
      fields: initialAddOrEditFields,
    },
  };
}

function openDelLicenseModal(state, data) {
  return {
    ...state,
    delLicenseModal: {
      ...state.delLicenseModal,
      isOpened: true,
      respErrMsg: '',
      fields: {
        id: data.id,
      },
    },
  };
}

function startDelLicense(state) {
  return {
    ...state,
    delLicenseActionStatus: ACTION_STATUS.LOGINING,
  };
}

function delLicenseSuccess(state) {
  return {
    ...state,
    delLicenseActionStatus: ACTION_STATUS.SUCCESS,
  };
}

function delLicenseFailure(state, err) {
  return {
    ...state,
    delLicenseActionStatus: ACTION_STATUS.ERROR,
    delLicenseModal: {
      ...state.delLicenseModal,
      respErrMsg: err && err.respMessage ? err.respMessage : '',
    },
  };
}

function initDelLicenseActionStatus(state) {
  return {
    ...state,
    delLicenseActionStatus: ACTION_STATUS.READY,
  };
}

function resetDelLicenseModal(state) {
  return {
    ...state,
    delLicenseModal: initialState.delLicenseModal,
  };
}

function startLoadLicenseNote(state) {
  return {
    ...state,
    loadLicenseNoteActionStatus: ACTION_STATUS.LOGINING,
  };
}

function loadLicenseNoteSuccess(state, resp) {
  const licenseNote = resp && resp.data && resp.data.length > 0 ? resp.data[0] : {};
  return {
    ...state,
    loadLicenseNoteActionStatus: ACTION_STATUS.SUCCESS,
    licenseNoteModal: {
      ...state.licenseNoteModal,
      isOpened: true,
      respErrMsg: '',
      fields: {
        id: licenseNote.id || null,
        note: licenseNote.note || '',
      },
    },
  };
}

function loadLicenseNoteFailure(state, err) {
  return {
    ...state,
    loadLicenseNoteActionStatus: ACTION_STATUS.ERROR,
    licenseNoteModal: {
      ...state.licenseNoteModal,
      respErrMsg: err && err.respMessage ? err.respMessage : '',
    },
  };
}

function initLoadLicenseNoteActionStatus(state) {
  return {
    ...state,
    loadLicenseNoteActionStatus: ACTION_STATUS.READY,
  };
}

function licenseNoteChangeInput(state, { name, value }) {
  return {
    ...state,
    licenseNoteModal: {
      ...state.licenseNoteModal,
      fields: {
        ...state.licenseNoteModal.fields,
        [name]: value,
      },
    },
  };
}

function startAddOrEditLicenseNote(state) {
  return {
    ...state,
    addOrEditLicenseNoteActionStatus: ACTION_STATUS.LOGINING,
  };
}

function addOrEditLicenseNoteSuccess(state) {
  return {
    ...state,
    addOrEditLicenseNoteActionStatus: ACTION_STATUS.SUCCESS,
  };
}

function addOrEditLicenseNoteFailure(state, err) {
  return {
    ...state,
    addOrEditLicenseNoteActionStatus: ACTION_STATUS.ERROR,
    licenseNoteModal: {
      ...state.licenseNoteModal,
      respErrMsg: err && err.respMessage ? err.respMessage : '',
    },
  };
}

function initAddOrEditLicenseNoteActionStatus(state) {
  return {
    ...state,
    addOrEditLicenseNoteActionStatus: ACTION_STATUS.READY,
  };
}

function resetLicenseNoteModal(state) {
  return {
    ...state,
    licenseNoteModal: initialState.licenseNoteModal,
  };
}

export default createReducer(initialState, {
  [ON_LICENSE_QUERY_INPUT_CHANGE]: onLicenseQueryInputChange,
  [START_LOAD_LICENSE_EMPLOYEE_OPTIONS]: startLoadLicenseEmployeeOptions,
  [LOAD_LICENSE_EMPLOYEE_OPTIONS_SUCCESS]: loadLicenseEmployeeOptionsSuccess,
  [LOAD_LICENSE_EMPLOYEE_OPTIONS_FAILURE]: loadLicenseEmployeeOptionsFailure,
  [INIT_LOAD_LICENSE_EMPLOYEE_OPTIONS_ACTION_STATUS]: initLoadLicenseEmployeeOptionsActionStatus,
  [START_LOAD_LICENSE_INFO]: startLoadLicenseInfo,
  [LOAD_LICENSE_INFO_SUCCESS]: loadLicenseInfoSuccess,
  [LOAD_LICENSE_INFO_FAILURE]: loadLicenseInfoFailure,
  [INIT_LOAD_LICENSE_INFO_ACTION_STATUS]: initLoadLicenseInfoActionStatus,
  [SELECT_LICENSE_INFO]: selectLicenseInfo,
  [OPEN_ADD_OR_EDIT_LICENSE_MODAL]: openAddOrEditLicenseModal,
  [ADD_OR_EDIT_LICENSE_CHANGE_INPUT]: addOrEditLicenseChangeInput,
  [START_ADD_OR_EDIT_LICENSE]: startAddOrEditLicense,
  [ADD_OR_EDIT_LICENSE_SUCCESS]: addOrEditLicenseSuccess,
  [ADD_OR_EDIT_LICENSE_FAILURE]: addOrEditLicenseFailure,
  [INIT_ADD_OR_EDIT_LICENSE_ACTION_STATUS]: initAddOrEditLicenseActionStatus,
  [RESET_ADD_OR_EDIT_LICENSE_MODAL]: resetAddOrEditLicenseModal,
  [OPEN_DEL_LICENSE_MODAL]: openDelLicenseModal,
  [START_DEL_LICENSE]: startDelLicense,
  [DEL_LICENSE_SUCCESS]: delLicenseSuccess,
  [DEL_LICENSE_FAILURE]: delLicenseFailure,
  [INIT_DEL_LICENSE_ACTION_STATUS]: initDelLicenseActionStatus,
  [RESET_DEL_LICENSE_MODAL]: resetDelLicenseModal,
  [START_LOAD_LICENSE_NOTE]: startLoadLicenseNote,
  [LOAD_LICENSE_NOTE_SUCCESS]: loadLicenseNoteSuccess,
  [LOAD_LICENSE_NOTE_FAILURE]: loadLicenseNoteFailure,
  [INIT_LOAD_LICENSE_NOTE_ACTION_STATUS]: initLoadLicenseNoteActionStatus,
  [LICENSE_NOTE_CHANGE_INPUT]: licenseNoteChangeInput,
  [START_ADD_OR_EDIT_LICENSE_NOTE]: startAddOrEditLicenseNote,
  [ADD_OR_EDIT_LICENSE_NOTE_SUCCESS]: addOrEditLicenseNoteSuccess,
  [ADD_OR_EDIT_LICENSE_NOTE_FAILURE]: addOrEditLicenseNoteFailure,
  [INIT_ADD_OR_EDIT_LICENSE_NOTE_ACTION_STATUS]: initAddOrEditLicenseNoteActionStatus,
  [RESET_LICENSE_NOTE_MODAL]: resetLicenseNoteModal,
});
